import type { BannerProps } from "kubra-ux-forge";

export type BannerRole = "alert" | "status";

export const getBannerRole = (variant: BannerProps["variant"]): BannerRole => {
  switch (variant) {
    case "error":
    case "warning":
      return "alert";
    case "info":
    case "success":
      return "status";
    default:
      return "status";
  }
};
